import type { UseEntityCustomFieldsFormPayload } from '@hooks/useEntityCustomFieldsForm'

import FieldGroup from './components/FieldGroup'

interface EntityCustomFieldsProps {
  customFieldsForm: UseEntityCustomFieldsFormPayload,
}

const EntityCustomFields = (props: EntityCustomFieldsProps) => {
  const {
    customFieldsForm,
    customFieldsForm: {
      sortedCustomFieldGroups,
    },
  } = props

  return (
    <>
      {sortedCustomFieldGroups.map(customFieldGroup => (
        // @ts-expect-error TS2741
        <FieldGroup
          customFieldGroup={customFieldGroup}
          customFieldsForm={customFieldsForm}
          key={customFieldGroup.id}
        />
      ))}
    </>
  )
}

export default EntityCustomFields
